export default "__VITE_ASSET__069a51c2__"